import clsx from "clsx"

import convertToKebabCase from "@utils/convertToKebabCase"
import determineOverdueBucket from "@utils/determineOverdueBucket"

import styles from "./StatusDot.module.scss"
import { StatusDotProps } from "./StatusDot.types"

export default function StatusDot(props: StatusDotProps) {
    const { status, isOutstandingOrOverdue, dateDue } = props

    const kebabStatus =
        isOutstandingOrOverdue && dateDue
            ? `overdue-${determineOverdueBucket(dateDue)?.toLowerCase().replaceAll("_", "-")}`
            : convertToKebabCase(status)

    return <div className={clsx(styles.base, styles[kebabStatus])}></div>
}
